/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FEATURE_FLAG = "ALTERNATE_OLDEST_FIRST_VIEW" | "AVATARS" | "DEFAULT_QA_STORY_MODE" | "DISABLE_WARN_USER_OF_TOXIC_COMMENT" | "DISCUSSIONS" | "ENABLE_AMP" | "ENABLE_QA" | "ENABLE_RATINGS_AND_REVIEWS" | "EXTERNAL_MEDIA" | "FLATTEN_REPLIES" | "NEW_COMMENT_COUNT" | "READ_MORE_NEW_TAB" | "REDUCED_SECURITY_MODE" | "RTE_SARCASM" | "SECTIONS" | "SITE_MODERATOR" | "VIEWER_COUNT" | "%future added value";
export type AllCommentsTabContainer_settings = {
    readonly reaction: {
        readonly sortLabel: string;
    };
    readonly disableCommenting: {
        readonly enabled: boolean;
    };
    readonly featureFlags: ReadonlyArray<FEATURE_FLAG>;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_settings" | "CommentContainer_settings" | "PostCommentFormContainer_settings" | "ViewersWatchingContainer_settings">;
    readonly " $refType": "AllCommentsTabContainer_settings";
};
export type AllCommentsTabContainer_settings$data = AllCommentsTabContainer_settings;
export type AllCommentsTabContainer_settings$key = {
    readonly " $data"?: AllCommentsTabContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ReactionConfiguration",
            "kind": "LinkedField",
            "name": "reaction",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sortLabel",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "DisableCommenting",
            "kind": "LinkedField",
            "name": "disableCommenting",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlags",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PostCommentFormContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ViewersWatchingContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'c0bf770e5c0215205d059483270e5fcd';
export default node;
